(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('widgetPluviometros', WidgetPluviometros);

  function WidgetPluviometros() {
    //////////////////////////////////////////
    // Directive definition object
    var directive = {
        templateUrl: 'views/widgets/pluviometros/view.html',
        controller: 'WidgetPluviometrosCtrl',
        controllerAs: 'wctrl',
        restrict: 'A',
        scope: {
          widget: '=data'
        }
    };
    return directive;
  }
}());
